import HeaderBaseContent from "./base.header";
import HeaderTwoContent from "./header-two.content";
import {List} from "immutable";
import BaseContent from "../base.content";
import {CMSContentType} from "../CMSType";
import {HeaderBaseContentParams} from "./base.header";
import {IContentMapper} from "../content/base.content";
import {AContent} from "../base.content";
import {AContentDTO} from "../base.content";
import {cmsContentMapperFactory} from "../content/mappers";
import {cmsStringToType, cmsTypeToString} from "../constants";
import {ListContentDTO} from "../content";
import {ImageListContentDTO} from "../content/image-list.content";
import {DetailsDTO} from "../content";

export interface HeaderOneContentParams extends HeaderBaseContentParams<AContent>{
  icon?: string;
}

export class HeaderOneContent extends HeaderBaseContent<AContent> {
  readonly icon: string;

  constructor(data: HeaderOneContentParams) {
    super(CMSContentType.headerOne, data);
    this.icon = data.icon;
  }

  public addChild(header: HeaderTwoContent): this {
    return this.push(header);
  }

  updateListItem(oldItem: AContent, newItem: AContent): this {
    return this.updateList(this.items.set(this.items.indexOf(oldItem), newItem));
  }


  public getAllContent(): List<BaseContent> {
    return this.children
      // go throw all subheaders
      .map((headerTwo: HeaderTwoContent) => headerTwo.children)
      // make single level
      .flatten()
      .toList();
  }

  public hasContent(searchableContent: BaseContent): boolean {
    const contents = this.getAllContent();

    return contents.includes(searchableContent);
  }

  public setIcon(icon: string): this {
    return this._merge({icon});
  }

  public toJSON() {
    return {...super.toJSON(), icon: this.icon};
  }
}

export interface HeaderOneContentDTO extends AContentDTO {
  label: string;
  icon: string;
  children: Array<ListContentDTO | ImageListContentDTO | DetailsDTO | AContentDTO>;
}


export class HeaderOneContentMapper implements IContentMapper {
  toDTO(data: HeaderOneContent): HeaderOneContentDTO {
    return {
      label: data.label,
      icon: data.icon,
      type: cmsTypeToString(data.type),
      children: data.items.toArray()
        .map((item) => cmsContentMapperFactory(item.type).toDTO(item))
    };
  }

  fromDTO(data: HeaderOneContentDTO): HeaderOneContent {
    return new HeaderOneContent({
      label: data.label,
      icon: data.icon,
      items: data.children.map((item) =>
        cmsContentMapperFactory(cmsStringToType(item.type)).fromDTO(item)
      )
    });
  }
}




// WEBPACK FOOTER //
// ./src/api/club-cms/headers/header-one.content.ts